export enum LanguageEnum {
  EN = 'EN',
  VI = 'VI',
}

export interface Language {
  prefix: string
  value: string
}
